var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBadgeAditionalAttendance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#D9FFD9",
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.353 9.492a.067.067 0 00-.02.047V15h-6.416c-.323 0-.635.117-.878.33l-1.372 1.2V15h-2V7.333h7.127a.067.067 0 00.047-.02l1.2-1.2A.067.067 0 0014.994 6H6.667c-.737 0-1.334.597-1.334 1.333V15c0 .736.597 1.333 1.334 1.333h.666v1.52c0 .63.742.967 1.217.552l2.367-2.072h6.416c.737 0 1.334-.597 1.334-1.333V8.34c0-.06-.072-.09-.114-.048l-1.2 1.2z",
    fill: "green"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.805 6.195c.26.26.26.683 0 .943l-5.62 5.62a.733.733 0 01-1.037 0l-1.953-1.953a.667.667 0 11.943-.943l1.529 1.528 5.195-5.195c.26-.26.682-.26.943 0z",
    fill: "green"
  })));
}

export default SvgBadgeAditionalAttendance;